export const CreditCardVisaLogoIcon = ({
  width = 56,
  height = 37,
  title = "Visa Payment",
  ...rest
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 57 38"
      role="img"
      aria-label="Visa"
      {...rest}>
      <title>{title}</title>
      <path
        fill="#1434CB"
        d="m23.4 12.2-5.7 13.5H14l-2.8-10.8c0-.5-.4-1-.8-1.2-1.1-.5-2.3-.9-3.4-1.1l.1-.4H13c.8 0 1.5.6 1.6 1.4l1.5 7.8 3.6-9.2zm14.4 9.1c0-3.6-4.9-3.8-4.9-5.3 0-.5.5-1 1.5-1.1 1.2-.1 2.4.1 3.4.6l.6-2.9c-1-.4-2.2-.6-3.3-.6-3.4 0-5.9 1.8-5.9 4.5 0 1.9 1.7 3 3.1 3.7s1.8 1.1 1.8 1.7c0 .9-1.1 1.3-2.1 1.3-1.2 0-2.5-.3-3.6-.8l-.6 3c1.2.5 2.6.7 3.9.7 3.7-.2 6.1-2 6.1-4.8m9.1 4.4h3.2l-2.8-13.5h-3c-.7 0-1.2.4-1.5 1l-5.2 12.5h3.7l.7-2h4.5zM43 20.9l1.8-5.1 1.1 5.1zm-14.6-8.7-2.9 13.5H22l2.9-13.5z"></path>
    </svg>
  );
};
